import { useEffect, useRef, useState } from 'react';

export default function DeferredRender({children,fallback=null,rootMargin='500px'}){
  const host=useRef(null);const [ready,setReady]=useState(false);
  useEffect(()=>{
    if(ready)return undefined;
    if(!('IntersectionObserver'in window)){setReady(true);return undefined;}
    const observer=new IntersectionObserver(([entry])=>{if(entry.isIntersecting){setReady(true);observer.disconnect();}},{rootMargin});
    if(host.current)observer.observe(host.current);
    return()=>observer.disconnect();
  },[ready,rootMargin]);
  return <div ref={host}>{ready?children:fallback}</div>;
}
